<template>
  <div ref="modal" class="modal fade" :id="`modal-${modalCode}`" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" :class="$props.class">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <slot name="title"></slot>
          </h5>
          <button type="button" class="btn-close" @click="myModal.hide()"></button>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Modal} from 'bootstrap'

export default {
  name: "Modal",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    class: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      myModal: undefined,
      modalCode: undefined
    }
  },
  mounted() {
    this.myModal = new Modal(this.$refs.modal)
    this.modalCode = Math.round(Math.random() * 100000)
  },
  watch: {
    myModal: {
      handler(val) {
        this.$emit('update:modelValue', val._isShown)
      },
      deep: true
    },
    modelValue(newVal) {
      if (newVal) {
        this.myModal.show()
      } else {
        this.myModal.hide()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  border-radius: 20px;
  padding: 1.5em;

  .modal-title {
    text-align: center;
    padding: 0;
  }

  .modal-header {
    padding: 0 0 1rem 0;
  }

  .modal-body {
    padding: 0;
  }

  .modal-footer {
    padding: 0;

    button {
      min-width: 70px;
    }
  }
}

@media (max-width: 500px) {
  .modal-content {
    padding: 1em;
  }
}

</style>
